import { SIDE_MENU } from "./sideBarTypes"

const sideMenu = () => {
    return{
        type: SIDE_MENU,
    }
}

export default sideMenu;
